import React, { memo } from 'react'
import { Box, useTheme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export type TechnicalsTimeframeOption = {
    id: string
    label: string
}

type TechnicalsTimeframeToggleProps = {
    timeframes: TechnicalsTimeframeOption[]
    value: string
    onChange: (timeframe: string) => void
}

const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        marginTop: theme.spacing(1.25)
    },
    chip: {
        border: 'none',
        background: 'transparent',
        color: theme.palette.text.secondary,
        fontSize: 12.5,
        fontWeight: 500,
        lineHeight: 1.2,
        padding: theme.spacing(0.6, 1.1),
        borderRadius: 6,
        cursor: 'pointer',
        fontFamily: 'inherit',
        '&:hover': {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.action.hover
        }
    },
    chipActive: {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.selected,
        fontWeight: 600
    }
}))

const TechnicalsTimeframeToggle = ({ timeframes, value, onChange }: TechnicalsTimeframeToggleProps) => {
    const { classes, cx } = useStyles()
    const theme = useTheme()

    if (!timeframes.length) return null

    return (
        <Box className={classes.root} role="tablist" aria-label="Technicals timeframe">
            {timeframes.map((tf) => {
                const selected = tf.id === value
                return (
                    <button
                        key={tf.id}
                        type="button"
                        role="tab"
                        aria-selected={selected}
                        className={cx(classes.chip, selected && classes.chipActive)}
                        onClick={() => onChange(tf.id)}
                        style={
                            selected
                                ? {
                                      backgroundColor:
                                          theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.12)' : theme.palette.action.selected
                                  }
                                : undefined
                        }
                    >
                        {tf.label}
                    </button>
                )
            })}
        </Box>
    )
}

export default memo(TechnicalsTimeframeToggle)
